import { render } from "./VisualizarServicoModal.vue?vue&type=template&id=4c96d982&ts=true"
import script from "./VisualizarServicoModal.vue?vue&type=script&lang=ts"
export * from "./VisualizarServicoModal.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__